import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { EmailTemplateCatalog, getEmailTemplates } from '../endpoints/emailTemplates';

// The catalog is static for a deploy, so it never goes stale.
export const useEmailTemplatesQuery = (): UseQueryResult<EmailTemplateCatalog, AxiosError> =>
    useQuery({
        queryKey: ['email-templates'],
        staleTime: Infinity,
        queryFn: getEmailTemplates,
    });
